import { Facets, SearchState } from '../../../models';
import { GETTERS_KEYS } from '../../store.const';
import { RootStoreState } from '../../store.interfaces';
import { SEARCH_GETTERS_KEYS } from '../search.const';
import { SearchGetter } from '../search.interfaces';

export class ShowSearchComponentsGetter implements SearchGetter {

  getters = {
    [SEARCH_GETTERS_KEYS.searchHasNoResults]: (searchState: SearchState, getters: any): boolean =>
      !!searchState.query
      && !searchState.loading
      && !getters[SEARCH_GETTERS_KEYS.hasResults],
    [SEARCH_GETTERS_KEYS.showFallbackFilters]: (searchState: SearchState, getters: any): boolean =>
      getters[SEARCH_GETTERS_KEYS.searchHasNoResults]
      && this.hasFallbackFacetsResults(getters),
    [SEARCH_GETTERS_KEYS.showPartials]: (searchState: SearchState, getters: any): boolean =>
      getters[SEARCH_GETTERS_KEYS.searchHasNoResults]
      && !this.hasFallbackFacetsResults(getters)
      && !!searchState.partialResults.length,
    [SEARCH_GETTERS_KEYS.showNoResults]: (searchState: SearchState, getters: any): boolean =>
      getters[SEARCH_GETTERS_KEYS.searchHasNoResults]
      && !searchState.partialResults.length
      && !this.hasFallbackFacetsResults(getters),
    [SEARCH_GETTERS_KEYS.showEmptySearch]: (searchState: SearchState): boolean =>
      !searchState.loading
      && !searchState.query
  };

  hasFallbackFacetsResults(getters: any): boolean {
    const compulsoryFacets: Facets = getters[SEARCH_GETTERS_KEYS.compulsoryFacets];
    return Object.values(compulsoryFacets).some(facet => facet.filters.some(filter => !!filter.count));
  }
}
